/**
 * Вычисляет расстояние между краем контейнера и краем элемента, который выходит за контейнер
 */
export function calculateScrollDistance(_ref) {
  var items = _ref.items,
    container = _ref.container,
    direction = _ref.direction;
  var scrollDistance = 0;
  var containerRect = container.getBoundingClientRect();

  // Используем some, чтобы не обходить весь массив элементов
  items.some(function (item) {
    var itemRect = item.getBoundingClientRect();
    if (direction === 'left') {
      // Если скроллим влево, то проверяем, что левая граница элемента находится левее левой границы контейнера
      if (containerRect.left < itemRect.left) {
        return false;
      }
      scrollDistance = containerRect.left - itemRect.left;
    } else {
      // Если скроллим вправо, то проверяем, что правая граница элемента находится правее правой границы контейнера
      if (containerRect.right > itemRect.right) {
        return false;
      }
      scrollDistance = itemRect.right - containerRect.right;
    }
    return true;
  });
  return scrollDistance;
}